import React, { useEffect, useRef, useState } from 'react';
import './CustomTemplate.less';
import { Col, Row } from 'antd';
import TemplateReport from './TemplateReport';
import { useFetchTemplatesQuery } from '../service';
import { useNavigate } from "react-router-dom";
import CustomTemplateForm from './CustomTemplateForm';

type Props = {
    templateGuid: string;
};

export default function CustomTemplate({ templateGuid }: Props) {
    const navigate = useNavigate();

    const isAddingTemplateRef = useRef<boolean>(false);
    const [name, setName] = useState<string>('');
    const [header, setHeader] = useState<string>('');
    const [footer, setFooter] = useState<string>('');
    const [logo, setLogo] = useState<string>('');
    const [showHowToFix, setShowHowToFix] = useState<boolean>(true);

    const { data: templates } = useFetchTemplatesQuery();

    useEffect(() => {
        if (templates && templateGuid !== 'new') {
            const existingTemplate = templates.find((template) => template.guid === templateGuid);

            if (!existingTemplate) {
                // If the last page visited was on templates/new, don't redirect
                if (!isAddingTemplateRef.current) {
                    navigate('/white-label/templates');
                }
                return;
            }

            setName(existingTemplate.name);
            setHeader(existingTemplate.content_blocks.header);
            setFooter(existingTemplate.content_blocks.footer);
            setLogo(existingTemplate.logo);
            setShowHowToFix(existingTemplate.show_how_to_fix_in_pdf !== false);
        } else if (templateGuid === 'new') {
            isAddingTemplateRef.current = true;
        }
    }, [navigate, templateGuid, templates]);

    useEffect(() => {
        if (templateGuid === 'default') {
            navigate('/white-label/templates');
        }
    }, [navigate, templateGuid]);

    return (
        <div className="white-label-template-layout">
            <Row
                className="pdf-template"
                gutter={[16, 16]}
                type="flex"
            >
                <Col
                    span={12}
                    className="form-col"
                >
                    <CustomTemplateForm
                        templateGuid={templateGuid}
                        nameValue={name}
                        headerValue={header}
                        footerValue={footer}
                        logoValue={logo}
                        onNameChange={setName}
                        onHeaderChange={setHeader}
                        onFooterChange={setFooter}
                        onLogoChange={setLogo}
                        showHowToFixValue={showHowToFix}
                        onShowHowToFixChange={setShowHowToFix}
                    />
                </Col>
                <Col
                    span={12}
                    className="preview-col"
                >
                    <TemplateReport
                        templateGuid={templateGuid}
                        logo={logo}
                        header={header}
                        footer={footer}
                    />
                </Col>
            </Row>
        </div>
    );
}
